// extracted by mini-css-extract-plugin
var _1 = "ra-search-results";
var _2 = "ra-search-results-section-action";
var _3 = "ra-search-results-section-artists";
var _4 = "ra-search-results-section-artworks";
var _5 = "ra-search-results-section-top";
var _6 = "ra-search-results-section-top-summary";
export { _1 as "searchResultsCls", _2 as "searchResultsSectionActionCls", _3 as "searchResultsSectionArtistsCls", _4 as "searchResultsSectionArtworksCls", _5 as "searchResultsSectionTopCls", _6 as "searchResultsSectionTopSummaryCls" }
